import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom-v6'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  Card,
  CardHeader,
  CardTitle,
  Empty,
  EmptyHeader,
  EmptyTitle,
  Skeleton,
} from '@clouway/ui'
import { Pencil, Plus, Trash2 } from 'lucide-react'

import { useDeleteNetwork, useNetworks } from '../hooks'

export function NetworksList() {
  const { t } = useTranslation('feature')
  const { t: tCommon } = useTranslation('common')
  const { data: networks, isLoading } = useNetworks()
  const { mutate: remove } = useDeleteNetwork()

  if (isLoading) {
    return (
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-2">
        <Skeleton className="h-20 w-full" />
        <Skeleton className="h-20 w-full" />
      </div>
    )
  }

  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col gap-3">
      <div className="flex justify-end">
        <Button asChild>
          <Link to="/networks/new">
            <Plus className="size-4" />
            {tCommon('networks.register')}
          </Link>
        </Button>
      </div>

      {networks && networks.length === 0 && (
        <Empty>
          <EmptyHeader>
            <EmptyTitle>{t('network.list.emptyMessage')}</EmptyTitle>
          </EmptyHeader>
        </Empty>
      )}

      {networks?.map((network) => (
        <Card key={network.id}>
          <CardHeader>
            <div className="flex items-start justify-between gap-2">
              <div>
                <CardTitle className="text-sm">{network.name}</CardTitle>
                <p className="text-muted-foreground text-sm">{network.apn}</p>
              </div>
              <div className="flex gap-1">
                <Button asChild size="icon" variant="ghost" aria-label="edit">
                  <Link to={`/networks/${network.id}/edit`}>
                    <Pencil className="size-4" />
                  </Link>
                </Button>
                <AlertDialog>
                  <AlertDialogTrigger asChild>
                    <Button size="icon" variant="ghost" aria-label="delete">
                      <Trash2 className="size-4" />
                    </Button>
                  </AlertDialogTrigger>
                  <AlertDialogContent>
                    <AlertDialogHeader>
                      <AlertDialogTitle>{t('network.list.deleteNetwork')}</AlertDialogTitle>
                      <AlertDialogDescription>
                        {t('network.list.deleteNetworkDescription', { network: network.name })}
                      </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                      <AlertDialogCancel>{tCommon('ui.button.cancel')}</AlertDialogCancel>
                      <AlertDialogAction onClick={() => remove(network.id)}>
                        {tCommon('ui.button.confirm')}
                      </AlertDialogAction>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialog>
              </div>
            </div>
          </CardHeader>
        </Card>
      ))}
    </div>
  )
}
